import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-add-tipo-allegato-modal',
  templateUrl: './add-tipo-allegato-modal.component.html',
  styleUrls: ['./add-tipo-allegato-modal.component.scss']
})
export class AddTipoAllegatoModalComponent implements OnInit {

  public userInput : FormControl = new FormControl(null, Validators.required);

  ngOnInit() {
  }

  constructor(
    public dialogRef: MatDialogRef<AddTipoAllegatoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { header : string, text : string, modalParam:any}) {
      
    }

  onNoClick(): void {
    this.dialogRef.close();
  }

  sendResult(){
    this.dialogRef.close({ status : true, data : this.userInput.value});
  }

}
